import { inject, observer } from 'mobx-react';
import styles from './index.module.less';
import ProductMaster from '../ProductMaster';

/**
 * 产品顶部信息左边
 */
function Index() {
  return (
    <div className={styles.component}>
      <ProductMaster />
    </div>
  );
}

export default inject('area', 'product')(observer(Index));
